import React from "react";
import { IoIosArrowDown, IoIosArrowForward } from "react-icons/io";
import { FcDatabase } from "react-icons/fc";
import { DiDatabase } from "react-icons/di";
import { MdOutlineBackupTable } from "react-icons/md";
import { LuTable2 } from "react-icons/lu";
import { FaColumns } from "react-icons/fa";
import { MdOutlineViewColumn } from "react-icons/md";

const DatabaseSection = ({
  sectionsOpen,
  handleSectionClick,
  handleContextMenu,
  databaseCount,
  databaseLinks,
  activeDatabaseId,
  handleDatabaseClick,
  activeTableCount,
  handleTableCountClick,
  tableCountsVisible,
  handleTableClick,
  activeTable,
  activeColumn,
  handleColumnClick,
  tableColumns,
  columnCountsVisible,
  handleColumnCountClick,
  selectedDatabase,
  setSelectedDatabase,
}) => {
  return (
    <>
      <a
        href="#"
        className="database-gui-sidebar-link-container"
        onClick={() => handleSectionClick("databases")}
        onContextMenu={(event) => handleContextMenu(event, "databases")}
      >
        {sectionsOpen.databases ? (
          <IoIosArrowDown className="database-gui-sidebar-arrow-icon" />
        ) : (
          <IoIosArrowForward className="database-gui-sidebar-arrow-icon" />
        )}
        <FcDatabase size={18} style={{ marginRight: "8px" }} />
        <span style={{ fontWeight: "600" }}>
          Databases ({databaseCount !== null ? databaseCount : "0"})
        </span>
      </a>

      {sectionsOpen.databases &&
        databaseLinks.map((db) => (
          <div
            className={`database-gui-database-container ${
              activeDatabaseId === db.id ? "active" : ""
            }`}
            key={db.id}
          >
            <a
              href={`#${db.id}`}
              className={`database-gui-sidebar-link ${
                activeDatabaseId === db.id ? "active" : ""
              }`}
              onClick={() => handleDatabaseClick(db.id)}
              onContextMenu={(event) =>
                handleContextMenu(event, "database", db.id)
              }
              title={db.label}
            >
              {sectionsOpen.openDatabaseId === db.id ? (
                <IoIosArrowDown className="database-gui-sidebar-arrow-icon" />
              ) : (
                <IoIosArrowForward className="database-gui-sidebar-arrow-icon" />
              )}
              <DiDatabase
                size={18}
                style={{ marginRight: "8px", color: "#ac9230" }}
              />
              <span>{db.label}</span>
            </a>

            {sectionsOpen.openDatabaseId === db.id && (
              <>
                <div
                  className={`database-gui-table-count ${
                    activeTableCount === db.id ? "active" : ""
                  }`}
                  onClick={() => handleTableCountClick(db.id)}
                >
                  {sectionsOpen.openTables === db.id ? (
                    <IoIosArrowDown className="database-gui-sidebar-arrow-icon" />
                  ) : (
                    <IoIosArrowForward className="database-gui-sidebar-arrow-icon" />
                  )}
                  <MdOutlineBackupTable
                    size={16}
                    style={{ marginRight: "8px", color: "#2596be" }}
                  />
                  <span style={{ fontWeight: "600" }}>
                    Tables ({db.tableCount !== null ? db.tableCount : "0"})
                  </span>
                </div>

                {tableCountsVisible[db.id] && (
                  <div className="database-gui-table-list">
                    {Array.isArray(db.tables) ? (
                      db.tables.map((table) => {
                        const key = `${db.id}.${table}`;
                        const columns =
                          (tableColumns && tableColumns[key]) || [];
                        const isOpen =
                          columnCountsVisible && columnCountsVisible[key];

                        return (
                          <div key={table} className="database-gui-table-with-columns">
                            <div
                              className={`database-gui-table-item ${
                                activeTable === table ? "active" : ""
                              }`}
                              onClick={() => handleTableClick(table, db.id)}
                              onContextMenu={(event) =>
                                handleContextMenu(event, "tables", db.id, table)
                              }
                              title={table}
                            >
                              {/* Table arrow toggle */}
                              {sectionsOpen.openTableId ===
                              `${db.id}.${table}` ? (
                                <IoIosArrowDown className="database-gui-sidebar-arrow-icon" />
                              ) : (
                                <IoIosArrowForward className="database-gui-sidebar-arrow-icon" />
                              )}
                              <LuTable2
                                size={14}
                                style={{ marginRight: "8px", color: "#2596be" }}
                              />
                              <span>{table}</span>
                            </div>

                            {/* Column toggle section */}
                            {sectionsOpen.openTableId === `${db.id}.${table}` &&
                              columns.length > 0 && (
                                <>
                                  <div
                                    className="database-gui-column-count"
                                    onClick={() => handleColumnCountClick(key)}
                                  >
                                    {isOpen ? (
                                      <IoIosArrowDown className="database-gui-sidebar-arrow-icon" />
                                    ) : (
                                      <IoIosArrowForward className="database-gui-sidebar-arrow-icon" />
                                    )}
                                    <FaColumns
                                      size={12}
                                      style={{
                                        marginRight: "8px",
                                        color: "#53bba6",
                                      }}
                                    />
                                    <span style={{ fontWeight: "600" }}>
                                      Columns ({columns.length})
                                    </span>
                                  </div>

                                  {isOpen && (
                                    <div className="database-gui-column-list">
                                      {columns.map((col) => (
                                        <div 
                                          key={col} 
                                          className={`database-gui-column-item ${
                                            activeColumn === col ? "active" : ""
                                          }`}
                                          title={col}
                                          onClick={() => handleColumnClick(col, table, db.id)}
                                          onContextMenu={(event) =>
                                            handleContextMenu(event, "columns", db.id, table, col)
                                          }
                                        >
                                          <MdOutlineViewColumn
                                            size={16}
                                            style={{
                                              marginRight: "8px",
                                              color: "#53bba6",
                                            }}
                                          />
                                          <span>{col}</span>
                                        </div>
                                      ))}
                                    </div>
                                  )}
                                </>
                              )}
                          </div>
                        );
                      })
                    ) : (
                      <p>No tables available</p>
                    )}
                  </div>
                )}
              </>
            )}
          </div>
        ))}
    </>
  );
};

export default DatabaseSection;
